import React from 'react';
import PropTypes from 'prop-types';
import { Flex, LocationIcon, Pill } from '@edreamsodigeo/prisma-design-system';

// eslint-disable-next-line react/prop-types
const LocationPill = ({ iconSize, children }) => {
  return (
    <Pill
      type="promotional"
      sx={{
        pl: 'base',
        py: '2x_small',
        borderRadius: 'full',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      }}
    >
      <Flex sx={{ lineHeight: '12px' }} my="tiny">
        <Flex alignSelf="flex-start" flexShrink={0}>
          <LocationIcon size={iconSize}></LocationIcon>
        </Flex>
        <Flex ml="2x_small">{children}</Flex>
      </Flex>
    </Pill>
  );
};

export default LocationPill;

LocationPill.propTypes = {
  iconSize: PropTypes.oneOf(['tiny', 'small', 'medium', 'large', 'xlarge']),
};

LocationPill.defaultProps = {
  iconSize: 'medium',
};
